import React from 'react'
import { Control, FieldErrors, UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form'
import { t } from 'ttag'
import { FormData } from '../../ChallengeAdmin'
import { CustomTypeCategory } from '../../../../services/CustomTypes'
import { CompanyId, GoalWithProgress } from '../../../../services/api.types'
import ChallengeTotalPoints from '../ChallengeTotalPoints/ChallengeTotalPoints'
import YumMediumTitle from '../../../../components/YumMediumTitle/YumMediumTitle'

interface ChallengeStepTotalPointsProps {
  register: UseFormRegister<FormData>
  control: Control<FormData>
  watch: UseFormWatch<FormData>
  setValue: UseFormSetValue<FormData>
  errors: FieldErrors<FormData>
  activityType: CustomTypeCategory
  goals: GoalWithProgress[]
  companyId: CompanyId
}

/**
 * Component for configuring wellness points challenges.
 * Shown as a separate step after Period selection.
 * Only displayed when activity type is TOTAL_POINTS.
 */
export default function ChallengeStepTotalPoints(props: ChallengeStepTotalPointsProps) {
  const { control, watch, register, setValue, errors, activityType, goals, companyId } = props

  // Only show this step for TOTAL_POINTS activity type
  if (activityType !== CustomTypeCategory.TOTAL_POINTS) {
    return null
  }

  return (
    <>
      {/* <YumMediumTitle>{t`Wellness points challenges`}</YumMediumTitle> */}
      <ChallengeTotalPoints
        control={control}
        watch={watch}
        register={register}
        setValue={setValue}
        errors={errors}
        goals={goals}
        companyId={companyId}
      />
    </>
  )
}
